module.exports = __webpack_public_path__ + "static/media/kingdom.5276a865.png";